import { useT } from "@/lib/i18n/I18nProvider";

export function NewReportBadge({ className = "" }: { className?: string }) {
  const { locale } = useT();
  return (
    <span
      className={
        "inline-flex items-center gap-1 rounded-full bg-accent/12 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-accent ring-1 ring-inset ring-accent/25 " +
        className
      }
      aria-label={locale === "bg" ? "Нов доклад" : "New report"}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-accent" aria-hidden />
      {locale === "bg" ? "Ново" : "New"}
    </span>
  );
}